export default __webpack_public_path__ + "static/media/3.6ea72f12.jpg";